const Home = () => {
    return (
        <html>
            <body>
                <h1>This will be a site for Jonah Lutchmedial!</h1>
                <p>Eventually I will post projects and web apps</p>
            </body>
        </html> 
        )}

export default Home